import React from 'react';
import Link from 'next/link';
import { BreadcrumbsProps } from 'views/Questions/components/Breadcrumbs/Breadcrumbs.types';
import { subjects } from 'shared/constants/subjects';
import { grades } from 'shared/constants/grades';
import Select from 'views/Questions/components/Select';
import { QuestionGrade, QuestionSubject } from 'views/Questions/Question.types';
import { SubjectType } from 'shared/constants/subjects.types';
import { GradeType } from 'shared/constants/grades.types';
import styles from './Breadcrumbs.module.css';

const Breadcrumbs = ({
  edit,
  categories,
  setCategories,
  grade,
  setGrade,
  categoryFromData,
  gradeFromData,
}: BreadcrumbsProps) => {
  const subjectLabel = subjects.find((i) => i.link === categories.link)?.name;
  const gradeLabel = grades.find((i) => i.value === grade.value.toString())?.label;

  const isSubjectType = (i: Record<string, unknown>): i is SubjectType =>
    i['name'] !== undefined;
  const isGradeType = (i: Record<string, unknown>): i is GradeType =>
    i?.['label'] !== undefined;

  const updateBreadCrumbsItem = (value: QuestionSubject | QuestionGrade) => {
    if (isSubjectType(value)) {
      setCategories(value);
    }

    if (isGradeType(value)) {
      setGrade(value);
    }
  };

  return (
    <ul
      className={styles.breadcrumbs}
      itemScope
      itemType="https://schema.org/BreadcrumbList"
    >
      <li itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
        <Link className={styles.breadcrumbs__item} href="/categories">
          <a itemProp="item" data-qa-marker="bread_crumbs_item" title="Все предметы">
            <span itemProp="name">Все предметы</span>
            <meta itemProp="position" content="0" />
          </a>
        </Link>
      </li>
      <span className={styles.breadcrumbs__separator}>/</span>
      {!edit && (
        <>
          <li itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
            <Link href={`/categories/${categoryFromData.link}`}>
              <a
                data-qa-marker="bread_crumbs_item"
                title={categoryFromData.name.replace(/[-]/g, '')}
                itemProp="item"
              >
                <span itemProp="name">{categoryFromData.name.replace(/[-]/g, '')}</span>
                <meta itemProp="position" content="1" />
              </a>
            </Link>
          </li>
          <span className={styles.breadcrumbs__separator}>/</span>
          <li itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
            <Link
              href={`/categories/${categoryFromData.link}?klass=${gradeFromData.value}`}
            >
              <a
                data-qa-marker="bread_crumbs_item"
                title={gradeFromData.label}
                itemProp="item"
              >
                <span itemProp="name">{gradeFromData.label}</span>
                <meta itemProp="position" content="2" />
              </a>
            </Link>
          </li>
        </>
      )}
      {edit && subjectLabel && gradeLabel && (
        <>
          <Select
            classNameLabel={styles.breadcrumbs__item}
            classNameOptions={styles.options__subject}
            options={subjects}
            onClick={(value: QuestionSubject | QuestionGrade) =>
              updateBreadCrumbsItem(value)
            }
          >
            {subjectLabel.replace(/[-]/g, '')} ▾
          </Select>
          <span className={styles.breadcrumbs__separator}>/</span>
          <Select
            classNameLabel={styles.breadcrumbs__item}
            classNameOptions={styles.options__grade}
            options={grades}
            onClick={(value: QuestionSubject | QuestionGrade) =>
              updateBreadCrumbsItem(value)
            }
          >
            {gradeLabel} ▾
          </Select>
        </>
      )}
    </ul>
  );
};

export default Breadcrumbs;
